import { render, staticRenderFns } from "./Planes.vue?vue&type=template&id=1626c1b0&scoped=true&"
import script from "./Planes.vue?vue&type=script&lang=js&"
export * from "./Planes.vue?vue&type=script&lang=js&"
import style0 from "./Planes.vue?vue&type=style&index=0&id=1626c1b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1626c1b0",
  null
  
)

export default component.exports